import { ComboBox } from '@domgen/base-design-system-2.0/atoms/ComboBox';
import { Input } from '@domgen/base-design-system-2.0/atoms/Input';
import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { AutoComplete } from '@domgen/shared/enums/autoComplete';
import { CircleCheck } from '../../../assets/icons/CircleCheck';
import type { ModelSerialLandingFormProps } from './ModelSerialLandingOnlineForm.types';

const styles = {
  root: 'flex flex-col gap-space-400',
  howToFindModel: 'text-center md:text-left',
};

export function ModelSerialLandingOnlineFormDefault({
  modelNumber,
  serialNumber,
  errors,
  loading,
  modelHintText,
  serialHintText,
  modelOptions,
  waitForSearchError,
  onModelInputChange,
  onModelSelect,
  onSerialChange,
  onOpenModelHelp,
}: ModelSerialLandingFormProps) {
  return (
    <div className={styles.root}>
      <ComboBox
        label="Model number"
        name="modelNumber"
        placeholder="Search for a model number"
        onInputChange={onModelInputChange}
        options={modelOptions}
        defaultValue={modelNumber}
        asyncProps={{ loading }}
        noResultsText="No appliances found"
        hintText={modelHintText}
        required
        onSelect={onModelSelect}
        hasSuccess={!!modelNumber && !errors.modelNumber}
        hasError={
          waitForSearchError && loading
            ? 'Please wait for the search to finish before continuing'
            : errors.modelNumber
        }
        allowCustomValue
        autoComplete={AutoComplete.OFF}
      />
      <Input
        hintText={serialHintText}
        placeholder="Enter a serial number"
        value={serialNumber}
        label="Serial number"
        name="serialNumber"
        onChange={onSerialChange}
        hasSuccess={!!serialNumber && !errors.serialNumber}
        hasError={errors.serialNumber}
        rightIcon={serialNumber && !errors.serialNumber ? <CircleCheck /> : undefined}
        autoComplete={AutoComplete.OFF}
      />
      <div className={styles.howToFindModel}>
        <TextLink onClick={onOpenModelHelp}>How to find your model number</TextLink>
      </div>
    </div>
  );
}
